// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyAOHf640n9btP4XpJzTZceOQmQgvJ_SK6g",
    authDomain: "examtimer-11c29.firebaseapp.com",
    databaseURL: "https://examtimer-11c29.firebaseio.com",
    projectId: "examtimer-11c29",
    storageBucket: "",
    messagingSenderId: "335984832576",
    appId: "1:335984832576:web:8a97580b7237ed82"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
